import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import KivoaiVideoList from './KivoaiVideoList';
import KivoaiVideoCreate from './KivoaiVideoCreate';
import KivoaiVideoEdit from './KivoaiVideoEdit';

export default {
    list: KivoaiVideoList,
    create: KivoaiVideoCreate,
    edit: KivoaiVideoEdit,
    icon: SmartDisplayIcon,
    recordRepresentation: (record: any) => record.key,
};
